import React, { act, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import Table from "../../../core/common/dataTable/index";
import { apibaseurl } from "../../../environment";
import Loader from "../../../core/common/selfLoder";

const Elibrary = () => {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("");
  const [tabs, setTabs] = useState([]);
  const [departmentData, setDepartmentData] = useState<any>([]);
  const [eLibraryData, setELibraryData] = useState<any>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null);
  const [selectedSubDepartment, setSelectedSubDepartment] = useState<any>(null);

  const { data: eTabs, loading: isLoading } = useApi("/api/get-elibrary-tabs", {
    method: "GET",
    autoCall: true,
  });

  const { data: department, loading: isLoadingdepartment } = useApi(
    "/api/elibrary-department",
    {
      method: "GET",
      autoCall: true,
    }
  );

  const {
    data: eLibrary,
    loading: isLoadingeLibrary,
    callApi: getELibraryData,
  } = useApi("/api/get-elibrary", {
    method: "POST",
    autoCall: false,
  });

  const fetchFilteredELibrary = async (
    department_id: string,
    sub_department: string,
    tab: string
  ) => {
    try {
      const payload = {
        department_id: department_id,
        sub_department: sub_department,
        tab: tab,
      };
      const res = await getELibraryData(payload);
      if (res.success) {
        setELibraryData(res?.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (eTabs?.success && eTabs.data.length > 0) {
      setTabs(eTabs.data);
      setActiveTab(eTabs.data[0].id);
    }

    if (department?.success && department.data.length > 0) {
      setDepartmentData(department.data);

      const defaultDepartment = department.data[0];
      setSelectedDepartment(defaultDepartment);

      if (defaultDepartment.sub_departments.length > 0) {
        setSelectedSubDepartment(defaultDepartment.sub_departments[0]);
      }
    }
  }, [department, eTabs]);

  useEffect(() => {
    if (selectedDepartment && selectedSubDepartment && activeTab) {
      fetchFilteredELibrary(
        selectedDepartment.ID,
        selectedSubDepartment.sub_department_id,
        activeTab
      );
    }
  }, [selectedDepartment, selectedSubDepartment, activeTab]);

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "SrNo",
      render: (text: string, record: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
      ),
      sorter: (a: any, b: any) => a.SrNo - b.SrNo,
    },
    {
      title: "Title",
      dataIndex: "title",
      sorter: (a: any, b: any) => a.title?.localeCompare(b.title),
    },
    // {
    //   title: "Department",
    //   dataIndex: "department",
    //   sorter: (a: any, b: any) => a.department?.localeCompare(b.department),
    // },
    {
      title: "Segment",
      dataIndex: "sub_department_name",
      sorter: (a: any, b: any) =>
        a.sub_department_name?.localeCompare(b.sub_department_name),
    },
    {
      title: "Resource",
      dataIndex: "tab_name",
      sorter: (a: any, b: any) => a.tab_name?.localeCompare(b.tab_name),
    },
    {
      title: "Uploaded By",
      dataIndex: "nick_name",
      sorter: (a: any, b: any) => a.nick_name?.localeCompare(b.nick_name),
    },
    {
      title: "File Type",
      dataIndex: "file_type",
      sorter: (a: any, b: any) => a.file_type?.localeCompare(b.file_type),
    },
    {
      title: "View File",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div className="action-icon d-inline-flex">
          {record.file ? (
            <a
              className="btn btn-sm btn-success me-2"
              href={`${apibaseurl}${record.file}`}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="ti ti-eye" />
            </a>
          ) : (
            "N/A"
          )}
        </div>
      ),
    },
  ];

  const formatDepartment = (department?: string) => {
switch(department){
  case "HR":
  return "Human Resource";
  case "IT":
    return "Information Technology"
    default:
      return department || "-";
}
  }


  return (
    <>
      <Loader loading={isLoadingdepartment} />;
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">E-Library</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Administration</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    E-Library
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex justify-content-center align-items-center flex-wrap gap-3">
                  {departmentData?.map((category: any, index: any) => {
                    const isActiveDepartment =
                      selectedDepartment?.ID === category.ID;

                    return (
                      <>
                        <div
                          key={index}
                          className="d-flex me-2 gap-2"
                          style={{
                            // border: "1px solid #E5E7EB",
                            padding: "5px",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "10px",
                            border: isActiveDepartment
                              ? "1px solid #2E3294"
                              : "1px solid #E5E7EB",
                          }}
                        >
                          <div>
                            <i
                              className={category.icon}
                              style={{
                                fontSize: "30px",
                                color: isActiveDepartment ? "#fff" : "#2E3294",
                              }}
                            ></i>
                          </div>
                          <div
                            style={{
                              fontSize: "15px",
                              fontWeight: "600",
                              // textTransform: "uppercase",
                            }}
                          >
                            {formatDepartment(category?.department)}
                            {/* {category?.department} */}
                          </div>

                          <div>
                            <div className="dropdown0">
                              <Link
                                to="#"
                                className="dropdown-toggle btn btn-white d-flex justify-content-center align-items-center"
                                data-bs-toggle="dropdown"
                                style={{
                                  backgroundColor: "rgb(46, 50, 148)",
                                  color: "white",
                                }}
                              ></Link>

                              <ul
                                className="dropdown-menu dropdown-menu-end "
                                style={{ textAlign: "center" }}
                              >
                                {category?.sub_departments?.map(
                                  (option: any, idx: any) => {
                                    const isActive =
                                      selectedDepartment?.ID === category.ID &&
                                      selectedSubDepartment?.sub_department_id ===
                                        option.sub_department_id;

                                    return (
                                      <li key={idx}>
                                        <Link
                                          to="#"
                                          className={`dropdown-item rounded-1 ${
                                            isActive
                                              ? "text-secondary fw-bold"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            setSelectedDepartment(category);
                                            setSelectedSubDepartment(option);
                                            fetchFilteredELibrary(
                                              category.ID,
                                              option.sub_department_id,
                                              activeTab
                                            );
                                          }}
                                        >
                                          {option.sub_department_name}
                                        </Link>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body d-flex">
              {tabs.map((tab: any)  => (
                <span
                  key={tab.id}
                  className={`me-3 ${
                    activeTab === tab.id
                      ? "text-primary fw-bold"
                      : "text-secondary"
                  }`}
                  style={{
                    cursor: "pointer",
                    textDecoration: activeTab === tab.id ? "underline" : "none",
                  }}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.tab_name}
                </span>
              ))}
            </div>
          </div>
          <div className="card">
            <Table
              dataSource={eLibraryData}
              columns={columns}
              Selection={false}
              showSearchInput={true}
            />
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Elibrary;
